export function addComma(str) {
    str=str.toString()
    var objRegex = new RegExp("(-?[0-9]+)([0-9]{3})");

    while (objRegex.test(str)) {
        str = str.replace(objRegex, "$1,$2");
    }

    return str;
}

export function gregorianToJalali(data) {
    let x = data.split("T");
    let [date, time] = x;
    let [year, month, day] = date.split("-");
    if (date && time && month && year && day) {
        if (month[0] === "0") month = month.slice(1);
        if (day[0] === "0") day = day.slice(1);
        let [hour, minute, second] = time.split(":");
        hour = parseInt(hour, 10);
        minute = parseInt(minute, 10);
        second = parseInt(second, 10);
        [hour, minute, second] = setTime(hour, minute, second);

        // converter
        let gy = parseInt(year, 10);
        let gm = parseInt(month, 10);
        let gd = parseInt(day, 10);
        let g_d_m, jy, jm, jd, gy2, days;
        g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
        gy2 = gm > 2 ? gy + 1 : gy;
        days =
            355666 +
            365 * gy +
            ~~((gy2 + 3) / 4) -
            ~~((gy2 + 99) / 100) +
            ~~((gy2 + 399) / 400) +
            gd +
            g_d_m[gm - 1];
        jy = -1595 + 33 * ~~(days / 12053);
        days %= 12053;
        jy += 4 * ~~(days / 1461);
        days %= 1461;
        if (days > 365) {
            jy += ~~((days - 1) / 365);
            days = (days - 1) % 365;
        }
        if (days < 186) {
            jm = 1 + ~~(days / 31);
            jd = 1 + (days % 31);
        } else {
            jm = 7 + ~~((days - 186) / 30);
            jd = 1 + ((days - 186) % 30);
        }
        [hour, minute, second] = setTime(hour, minute, second)
        return {
            year: jy,
            month: jm,
            day: jd,
            hour,
            minute,
            second,
        };
    } else {
        return {};
    }
}


export const setTime = (h, m, s) => {
    m += 30;
    h += 3;
    if (m >= 60) {
        const newM = m % 60;
        h += 1;
        m = newM;
    }
    if (h >= 24) {
        const newH = h % 24;
        h = newH;
    }
    return [h, m, s];
};

export function isInt(n){
    return Number(n) === n && n % 1 === 0;
}

export function isFloat(n){
    return Number(n) === n && n % 1 !== 0;
}